export const NAME = "core-user";
